import React from 'react';
import { Helmet } from 'react-helmet';
import WebDevelopment from './WebDevelopment';

const WebDevelopmentPage = () => (
  <>
    <Helmet>
      <title>Web Development | MilaajBrandset</title>
      <meta
        name="description"
        content="Our web development services offer cutting-edge solutions to build and optimize your website for better performance and user experience."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, web development, website design, user experience, digital solutions"
      />
      <meta property="og:title" content="Web Development | MilaajBrandset" />
      <meta
        property="og:description"
        content="Our web development services offer cutting-edge solutions to build and optimize your website for better performance and user experience."
      />
    </Helmet>
    <WebDevelopment />
  </>
);

export default WebDevelopmentPage;